import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form__radiogroup mb-24" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", { class: "invisible" }, " Asset Status ", -1 /* HOISTED */)
const _hoisted_3 = {
  for: "live",
  class: "form__radio"
}
const _hoisted_4 = {
  for: "paused",
  class: "form__radio"
}
const _hoisted_5 = {
  for: "completed",
  class: "form__radio"
}
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Asset Status",
    onCloseModal: _cache[4] || (_cache[4] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _createElementVNode("fieldset", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("label", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            id: "live",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.status) = $event)),
            type: "radio",
            name: "asset-status",
            value: "live"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, $setup.status]
          ]),
          _createTextVNode(" Live ")
        ]),
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            id: "paused",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.status) = $event)),
            type: "radio",
            name: "asset-status",
            value: "paused"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, $setup.status]
          ]),
          _createTextVNode(" Paused ")
        ]),
        _createElementVNode("label", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            id: "cancelled",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.status) = $event)),
            type: "radio",
            name: "asset-status",
            value: "cancelled"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, $setup.status]
          ]),
          _createTextVNode(" Cancelled ")
        ])
      ]),
      ($setup.error_message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.error_message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        disabled: $setup.loading,
        onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, " Cancel ", 8 /* PROPS */, _hoisted_7),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading' : $setup.loading }]),
        disabled: $setup.loading,
        onClick: $setup.updateAssetStatus
      }, " Save ", 10 /* CLASS, PROPS */, _hoisted_8)
    ]),
    _: 1 /* STABLE */
  }))
}